import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal, { ModalRef } from '@/components/@IntranetLibrary/Modal';
import BoxButton from '@/components/@IntranetLibrary/Button/BoxButton';
import { ConfirmFooter, ConfirmMessage } from './styles';

/**
 * 작성 중 코멘트 close-guard 확인 모달 — 코멘트 작성/수정 중 화면을 닫으려 할 때 노출.
 * 우상단 X / 백드롭은 "계속 수정" 과 동일(onKeepEditing).
 */

type UnsavedCommentConfirmModalProps = {
  open: boolean;
  /** "닫기" — 작성 중 코멘트 폐기 + 화면(모달) 실제 close. */
  onConfirmClose: () => void;
  /** "계속 수정" / 우상단 X / 백드롭 — 가드 모달만 닫고 입력창 유지. */
  onKeepEditing: () => void;
  /** 기본 Modal(1300)보다 높은 호스트 안에서 쓸 때 지정. */
  zIndex?: number;
};

const UnsavedCommentConfirmModal = ({
  open,
  onConfirmClose,
  onKeepEditing,
  zIndex,
}: UnsavedCommentConfirmModalProps) => {
  const { t } = useTranslation();
  const modalRef = useRef<ModalRef>(null);

  // 컨트롤드 open → imperative Modal 동기화.
  useEffect(() => {
    if (open) {
      modalRef.current?.open();
    } else {
      modalRef.current?.close();
    }
  }, [open]);

  return (
    <Modal
      ref={modalRef}
      title={''}
      size="x-small"
      {...(zIndex ? { sx: { zIndex } } : {})}
      // 우상단 X / 백드롭 = "계속 수정"(입력창 유지).
      handleClose={onKeepEditing}
      footerContent={
        <ConfirmFooter>
          <BoxButton variant="secondary" size="small" onClick={onConfirmClose}>
            {t('닫기')}
          </BoxButton>
          <BoxButton variant="primary" size="small" onClick={onKeepEditing}>
            {t('계속 수정')}
          </BoxButton>
        </ConfirmFooter>
      }
    >
      <ConfirmMessage>
        {t('작성중인 코멘트가 있습니다.\n화면을 닫으시겠어요?')}
      </ConfirmMessage>
    </Modal>
  );
};

export default UnsavedCommentConfirmModal;
